// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"personal-space-layout_mainContainer__1WPyY"};